import { PropsWithChildren, useEffect, useState } from "react";
import { Switch, makeStyles } from "@fluentui/react-components";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IPersonalSiteFilterProps } from "./personal-site-filter.props";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1em'
    }
});

export default function PersonalSiteFilter(props: PropsWithChildren<IPersonalSiteFilterProps>) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const [includeWorkspaces, setIncludeWorkspaces] = useState<boolean>(props.model?.includeWorkspaces === true);
    const [includeOneDrive, setIncludeOneDrive] = useState<boolean>(props.model?.includeOneDrive === true);

    useEffect(() => {
        props.onChange({ includeWorkspaces: includeWorkspaces, includeOneDrive: includeOneDrive });
    }, [includeWorkspaces, includeOneDrive]);

    return (
        <div className={styles.mainWrapper}>
            <Switch
                defaultChecked={includeWorkspaces}
                label={t('ppaPersonalSiteFilterIncludeWorkspacesLabel')}
                onChange={(e, v) => { setIncludeWorkspaces(v.checked) }} />
            <Switch
                defaultChecked={includeOneDrive}
                label={t('ppaPersonalSiteFilterIncludeOneDriveLabel')}
                onChange={(e, v) => { setIncludeOneDrive(v.checked) }} />
        </div>
    );
}